"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var easeInOutQuad = function easeInOutQuad(time, start, end, duration) {
  var elapsedTime = time;

  elapsedTime /= duration / 2;

  if (elapsedTime < 1) {
    return end / 2 * elapsedTime * elapsedTime + start;
  }

  elapsedTime -= 1;

  return -end / 2 * (elapsedTime * (elapsedTime - 2) - 1) + start;
};

exports.default = easeInOutQuad;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/in-page-anchors/js/easing.js
// module id = 1104
// module chunks = 4